"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STEAL_RULE_LABELS = exports.SHOP_FROZEN_LABELS = exports.SHOP_DEPOSIT_LABELS = exports.CUSTOMER_RECORD_LABELS = exports.AGENT_YEZZ_LABELS = exports.AGENT_WITHDRAW_FEE_LABELS = exports.AGENT_FROZEN_LABELS = exports.AGENT_DEPOSIT_LABELS = void 0;
exports.buildReportContent = buildReportContent;
exports.buildSubjectPrefix = buildSubjectPrefix;
exports.formatYesNo = formatYesNo;
exports.omitSensitive = omitSensitive;
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _toConsumableArray2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _typeof2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/typeof.js"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 【操作埋点】content 内容格式化工具
 * 实施时间：2026-05-25
 * 说明：将表单/配置对象格式化为上报字段 content，过滤敏感字段，供各业务页面与 reports 模块复用
 */

var SENSITIVE_KEYS = ['token', 'password', 'user_id', 'agent_id', 'son_id'];
function formatYesNo(val) {
  if (val === 1 || val === '1') return '是';
  if (val === 0 || val === '0') return '否';
  return val;
}
function omitSensitive(data) {
  if (!data || (0, _typeof2.default)(data) !== 'object') return data;
  var clone = Array.isArray(data) ? (0, _toConsumableArray2.default)(data) : _objectSpread({}, data);
  SENSITIVE_KEYS.forEach(function (key) {
    delete clone[key];
  });
  return clone;
}

/**
 * 将对象字段格式化为「标签：值」拼接字符串
 * @param {Object} data
 * @param {Object} labelMap 字段中文名映射
 * @param {Object} options
 * @param {string} options.prefix 前缀（如「代理商：张三(ID:1)」）
 * @param {Object} options.formatters 字段级格式化函数
 * @param {number} options.maxLen 最大长度
 */
function buildReportContent(data) {
  var labelMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$prefix = options.prefix,
    prefix = _options$prefix === void 0 ? '' : _options$prefix,
    _options$formatters = options.formatters,
    formatters = _options$formatters === void 0 ? {} : _options$formatters,
    _options$maxLen = options.maxLen,
    maxLen = _options$maxLen === void 0 ? 800 : _options$maxLen;
  var safe = omitSensitive(data);
  if (!safe || (0, _typeof2.default)(safe) !== 'object') {
    var _text = prefix || String(safe || '');
    return _text.length > maxLen ? _text.slice(0, maxLen) + '…' : _text;
  }
  var parts = [];
  Object.keys(safe).forEach(function (key) {
    var val = safe[key];
    if (val === undefined || val === null || val === '') return;
    var label = labelMap[key] || key;
    var display;
    if (formatters[key]) {
      display = formatters[key](val, safe);
    } else if (Array.isArray(val)) {
      display = val.join(',');
    } else {
      display = String(val);
    }
    parts.push("".concat(label, "\uFF1A").concat(display));
  });
  var text = parts.join('；');
  if (prefix) text = "".concat(prefix, "\uFF1B").concat(text);
  if (!text) return prefix || '';
  return text.length > maxLen ? text.slice(0, maxLen) + '…' : text;
}
function buildSubjectPrefix(name, id) {
  var subject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '对象';
  var label = name ? "\u300C".concat(name, "\u300D") : subject;
  return id != null && id !== '' ? "".concat(subject).concat(label, "(ID:").concat(id, ")") : "".concat(subject).concat(label);
}
var AGENT_FROZEN_LABELS = exports.AGENT_FROZEN_LABELS = {
  is_frozen: '账号冻结',
  is_allow_withdrawal: '允许提现',
  is_use_cheap: '使用优惠套餐',
  card_charges_type: '卡计费类型',
  second_charge: '2分钟计费',
  ten_charge: '10分钟计费',
  six_charge: '6分钟计费',
  cdb_charge: '充电宝计费'
};
var AGENT_YEZZ_LABELS = exports.AGENT_YEZZ_LABELS = {
  is_yezz: '认证状态',
  max_steal_order_right_ration: '最大掉单比例'
};
var AGENT_DEPOSIT_LABELS = exports.AGENT_DEPOSIT_LABELS = {
  is_deposit_sharing: '押金分成',
  store_deposit_sharing_ratio: '商户押金分成比例',
  agent_sharing_ratio: '代理分成比例'
};
var AGENT_WITHDRAW_FEE_LABELS = exports.AGENT_WITHDRAW_FEE_LABELS = {
  config_mode: '配置模式',
  withdraw_rate: '提现费率',
  withdraw_amount: '提现固定金额'
};
var SHOP_FROZEN_LABELS = exports.SHOP_FROZEN_LABELS = {
  is_frozen: '账号冻结',
  is_allow_withdrawal: '允许提现',
  is_use_cheap: '使用优惠套餐',
  is_steal_order_white: '掉单白名单',
  is_use_old_combo: '使用旧套餐'
};
var SHOP_DEPOSIT_LABELS = exports.SHOP_DEPOSIT_LABELS = {
  is_deposit_sharing: '押金分成',
  deposit_sharing_ratio: '商户押金分成比例',
  agent_sharing_ratio: '代理分成比例'
};
var CUSTOMER_RECORD_LABELS = exports.CUSTOMER_RECORD_LABELS = {
  contact: '联系方式',
  aid: '代理商ID',
  store_id: '商户ID',
  goods_sn: '设备SN',
  goods_type: '设备类型',
  record_type: '问题类型',
  status: '跟进状态',
  add_person: '登记人员',
  content: '反馈内容',
  record: '跟进记录'
};
var STEAL_RULE_LABELS = exports.STEAL_RULE_LABELS = {
  new_steal_switch: '掉单开关',
  missed_cycle_orders: '比例漏单基数',
  missed_rate: '比例漏单概率',
  missed_min_money: '比例漏单起漏金额',
  short_cycle_orders: '时间扣减基数',
  short_rate: '时间扣减概率',
  short_minute: '时间扣减分钟',
  show_fail_rate: '扣款失败概率',
  show_fail_min_money: '扣款失败起漏金额',
  missed_nologin_cycle_orders: '已完成漏单基数',
  missed_nologin_rate: '已完成漏单概率',
  missed_nologin_min_money: '已完成漏单起漏金额'
};